import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const GoroutinesParallelismDemo = () => {
  const [activeTab, setActiveTab] = useState('goroutines');
  // Goroutines demo state
  const [blinks, setBlinks] = useState([false, false, false]);
  const intervals = useRef([]);
  // Channels demo state
  const [queue, setQueue] = useState([]);
  const [sendCount, setSendCount] = useState(1);
  const channelCap = 2;

  // Start goroutines blinking
  const startBlink = () => {
    stopBlink();
    const intervalsArr = [500, 700, 900].map((ms, i) => {
      return setInterval(() => {
        setBlinks(prev => {
          const newState = [...prev];
          newState[i] = !newState[i];
          return newState;
        });
      }, ms);
    });
    intervals.current = intervalsArr;
  };
  const stopBlink = () => {
    intervals.current.forEach(clearInterval);
    intervals.current = [];
    setBlinks([false, false, false]);
  };

  // Channels demo: consumer removes from queue every 2s
  useEffect(() => {
    const consumer = setInterval(() => {
      setQueue(prev => (prev.length ? prev.slice(1) : prev));
    }, 2000);
    return () => clearInterval(consumer);
  }, []);

  const sendToChannel = () => {
    if (queue.length < channelCap) {
      setQueue(prev => [...prev, `Msg${sendCount}`]);
      setSendCount(prev => prev + 1);
    }
  };

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Демо: Горутины и каналы в Go</h3>
      <div style={styles.tabList}>
        <button
          onClick={() => {
            setActiveTab('goroutines'); stopBlink(); setQueue([]);
          }}
          style={activeTab === 'goroutines' ? styles.activeTab : styles.tab}
        >Горутины</button>
        <button
          onClick={() => { setActiveTab('channels'); stopBlink(); setQueue([]); }}
          style={activeTab === 'channels' ? styles.activeTab : styles.tab}
        >Каналы</button>
      </div>

      {activeTab === 'goroutines' && (
        <div style={styles.demoBlock}>
          <p>Нажмите «Запустить», чтобы запустить три «горутины», мигающие с разной скоростью.</p>
          <div style={styles.circleContainer}>
            {blinks.map((on, i) => (
              <motion.div
                key={i}
                animate={{ scale: on ? 1.2 : 1 }}
                transition={{ duration: 0.2 }}
                style={{ ...styles.circle, background: ['#f44336','#4caf50','#2196f3'][i] }}
              />
            ))}
          </div>
          <div style={styles.buttonRow}>
            <button onClick={startBlink} style={styles.runButton}>Запустить</button>
            <button onClick={stopBlink} style={styles.stopButton}>Остановить</button>
          </div>
        </div>
      )}

      {activeTab === 'channels' && (
        <div style={styles.demoBlock}>
          <p>Буферизованный канал (ёмкость {channelCap}). Отправляйте сообщения, они будут удаляться каждые 2 сек.</p>
          <div style={styles.buttonRow}>
            <button
              onClick={sendToChannel}
              style={queue.length < channelCap ? styles.runButton : styles.disabledButton}
              disabled={queue.length >= channelCap}
            >Отправить Msg{sendCount}</button>
          </div>
          <div style={styles.queueContainer}>
            {queue.map((msg, i) => (
              <div key={i} style={styles.queueItem}>{msg}</div>
            ))}
            {Array.from({ length: channelCap - queue.length }).map((_, i) => (
              <div key={i} style={styles.emptySlot} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: { maxWidth: 700, margin: '2rem auto', padding: '1rem', background: '#fff', borderRadius: 12,   border: '2px solid black',  },
  title: { textAlign: 'center', marginBottom: '1rem' },
  tabList: { display: 'flex', gap: 8, justifyContent: 'center', marginBottom: '1rem' },
  tab: { padding: '0.5rem 1rem', border: '1px solid #ccc', borderRadius: 6, background: '#f5f5f5', cursor: 'pointer' },
  activeTab: { padding: '0.5rem 1rem', border: '1px solid black', borderRadius: 6, background: 'black', color: '#fff', cursor: 'pointer', fontFamily: 'Roboto, monospace'  },
  demoBlock: { textAlign: 'center' },
  circleContainer: { display: 'flex', justifyContent: 'center', gap: '1rem', margin: '1rem 0' },
  circle: { width: 40, height: 40, borderRadius: '50%' },
  buttonRow: { display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '1rem' },
  runButton: { padding: '0.5rem 1rem', border: 'none', borderRadius: 6, background: 'green', color: '#fff', cursor: 'pointer', fontFamily: 'Roboto, monospace'},
  stopButton: { padding: '0.5rem 1rem', border: 'none', borderRadius: 6, background: '#f44336', color: '#fff', cursor: 'pointer', fontFamily: 'Roboto, monospace'},
  disabledButton: { padding: '0.5rem 1rem', border: 'none', borderRadius: 6, background: '#ccc', color: '#666', cursor: 'not-allowed', fontFamily: 'Roboto, monospace'},
  queueContainer: { display: 'flex', gap: '0.5rem', justifyContent: 'center', marginTop: '1rem' },
  queueItem: { padding: '0.5rem 1rem', background: '#4caf50', color: '#fff', borderRadius: 4 },
  emptySlot: { width: 60, height: 28, background: '#eee', borderRadius: 4 },
};

export default GoroutinesParallelismDemo;
